export default "__VITE_ASSET__4800d0e0__"